import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
    },
  },
  header: {
    backgroundColor: fade(theme.palette.grey[100], 0.3),
    display: 'flex',
    minWidth: theme.spacing(12.5),
    minHeight: theme.spacing(8),
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      height: theme.spacing(15.75),
      alignItems: 'flex-start',
    },
  },
  isHighlighted: {
    backgroundColor: theme.palette.secondary.lighter,
  },
  icon: {
    width: theme.spacing(4),
    height: 'auto',
    color: theme.palette.grey[200],
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: theme.spacing(1.5, 1.5, 1.5, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 2),
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  text: {
    color: theme.palette.primary.dark,
  },
}))

export default useStyles
